// source : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/parseInt#polyfill

const numberParseIntPolyfill = () => {
  if (Number.parseInt === undefined) {
    Number.parseInt = window.parseInt;
  }
};

export default numberParseIntPolyfill;
